import { render } from "./modal-add-batch.vue?vue&type=template&id=6f8a9dab&scoped=true"
import script from "./modal-add-batch.vue?vue&type=script&lang=js"
export * from "./modal-add-batch.vue?vue&type=script&lang=js"

import "./modal-add-batch.vue?vue&type=style&index=0&id=6f8a9dab&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8a9dab"]])

export default __exports__